export default __webpack_public_path__ + "static/media/calendar24.9d7029da.svg";